<template>
  <div class="audit-auth-owner-undo-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('auditAuthOwnerUndo.title')" :subtitle="$t('auditAuthOwnerUndo.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="goBack">
          {{ $t('auditAuthOwnerUndo.back') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) 房屋与业主信息面板 -->
    <div class="ds-panel ds-panel--padded" v-if="auditAuthOwnerUndoInfo.room">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('auditAuthOwnerUndo.page.roomInfoTitle') }}</span>
      </div>
      <div class="ds-info-grid">
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('auditAuthOwnerUndo.roomNumber') }}</span>
          <span class="ds-info-grid__value">{{ auditAuthOwnerUndoInfo.room.roomName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('auditAuthOwnerUndo.roomArea') }}</span>
          <span class="ds-info-grid__value ds-num">{{ auditAuthOwnerUndoInfo.room.builtUpArea || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('auditAuthOwnerUndo.roomType') }}</span>
          <span class="ds-info-grid__value">{{ auditAuthOwnerUndoInfo.room.roomSubTypeName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('auditAuthOwnerUndo.roomStatus') }}</span>
          <span class="ds-info-grid__value">{{ auditAuthOwnerUndoInfo.room.stateName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('auditAuthOwnerUndo.owner') }}</span>
          <span class="ds-info-grid__value">{{ auditAuthOwnerUndoInfo.room.ownerName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('auditAuthOwnerUndo.ownerPhone') }}</span>
          <span class="ds-info-grid__value ds-num">{{ auditAuthOwnerUndoInfo.room.link || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('auditAuthOwnerUndo.authPerson') }}</span>
          <span class="ds-info-grid__value">{{ auditAuthOwnerUndoInfo.appUserName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('auditAuthOwnerUndo.ownerPhone') }}</span>
          <span class="ds-info-grid__value ds-num">{{ auditAuthOwnerUndoInfo.link || '-' }}</span>
        </div>
      </div>
    </div>

    <!-- (3)(4) 房屋人员面板 + 表格 -->
    <div class="ds-panel">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('auditAuthOwnerUndo.housePersonnel') }}</span>
      </div>

      <ds-data-table :data="auditAuthOwnerUndoInfo.owners" density="default" border
        :empty-description="$t('auditAuthOwnerUndo.page.empty')">
        <el-table-column prop="url" :label="$t('auditAuthOwnerUndo.ownerFace')" align="center" width="100">
          <template slot-scope="scope">
            <el-image style="width: 60px; height: 60px;" :src="scope.row.url || '/img/noPhoto.jpg'"
              :preview-src-list="[scope.row.url]" fit="cover" class="border-radius"
              @click="viewOwnerFace(scope.row.url)"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('auditAuthOwnerUndo.name')" align="center" min-width="110" />
        <el-table-column prop="link" :label="$t('auditAuthOwnerUndo.contact')" align="center" width="130">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.link || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" :label="$t('auditAuthOwnerUndo.address')" align="center" min-width="180"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.address || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="idCard" :label="$t('auditAuthOwnerUndo.idCard')" align="center" min-width="150">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.idCard || '-' }}</span>
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <!-- (5) 审核表单面板 -->
    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('auditAuthOwnerUndo.audit') }}</span>
      </div>

      <el-form label-width="120px" class="ds-form">
        <el-form-item :label="$t('auditAuthOwnerUndo.action')">
          <el-select v-model="auditAuthOwnerUndoInfo.audit.state" class="w-full">
            <el-option disabled :value="''" :label="$t('auditAuthOwnerUndo.selectAudit')"></el-option>
            <el-option value="1100" :label="$t('auditAuthOwnerUndo.agree')"></el-option>
            <el-option value="1200" :label="$t('auditAuthOwnerUndo.reject')"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('auditAuthOwnerUndo.auditRemark')">
          <el-input type="textarea" :placeholder="$t('auditAuthOwnerUndo.requiredRemark')"
            v-model="auditAuthOwnerUndoInfo.audit.remark" :rows="4"></el-input>
        </el-form-item>

        <div class="ds-form-actions">
          <el-button icon="el-icon-back" @click="goBack">
            {{ $t('auditAuthOwnerUndo.back') }}
          </el-button>
          <el-button type="primary" icon="el-icon-check" @click="auditSubmit">
            {{ $t('auditAuthOwnerUndo.submit') }}
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { getRoomInfo, getOwnerList, auditAuthOwner } from '@/api/owner/auditAuthOwnerUndoApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'AuditAuthOwnerUndoList',
  components: {
    DsPageHeader,
    DsDataTable
  },
  data() {
    return {
      auditAuthOwnerUndoInfo: {
        room: {},
        roomId: '',
        owners: [],
        appUserName: '',
        link: '',
        audit: {
          state: '',
          remark: '',
          appUserId: ''
        }
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      this.auditAuthOwnerUndoInfo.audit.appUserId = this.$route.query.appUserId
      this.auditAuthOwnerUndoInfo.roomId = this.$route.query.roomId
      this.auditAuthOwnerUndoInfo.appUserName = this.$route.query.appUserName
      this.auditAuthOwnerUndoInfo.link = this.$route.query.link
      this.loadRoom()
      this.loadOwners()
    },
    async loadRoom() {
      try {
        const params = {
          page: 1,
          row: 1,
          roomId: this.auditAuthOwnerUndoInfo.roomId,
          communityId: getCommunityId()
        }
        const res = await getRoomInfo(params)
        this.auditAuthOwnerUndoInfo.room = res.rooms[0]
      } catch (error) {
        console.error('Failed to load room info:', error)
      }
    },
    async loadOwners() {
      try {
        const params = {
          page: 1,
          row: 100,
          roomId: this.auditAuthOwnerUndoInfo.roomId,
          communityId: getCommunityId()
        }
        const res = await getOwnerList(params)
        this.auditAuthOwnerUndoInfo.owners = res.data
      } catch (error) {
        console.error('Failed to load owners:', error)
      }
    },
    viewOwnerFace(url) {
      if (url) {
        // 预览图片逻辑
      }
    },
    async auditSubmit() {
      try {
        const auditInfo = {
          ...this.auditAuthOwnerUndoInfo.audit,
          communityId: getCommunityId()
        }
        const res = await auditAuthOwner(auditInfo)
        if (res.code !== 0) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success(this.$t('common.operationSuccess'))
        this.$router.go(-1)
      } catch (error) {
        this.$message.error(this.$t('auditAuthOwnerUndo.submitFailed') + error)
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.audit-auth-owner-undo-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &--padded {
    padding: var(--ds-spacing-lg);
  }
}

/* 面板标题栏 */
.ds-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: var(--ds-spacing-md);
  margin-bottom: var(--ds-spacing-lg);
  border-bottom: 1px solid var(--ds-gray-200);
}

.ds-panel__title {
  font-size: var(--ds-font-size-lg);
  font-weight: 600;
  color: var(--ds-gray-800);
}

/* 表单 */
.ds-form {
  .el-form-item {
    margin-bottom: var(--ds-spacing-lg);
  }
}

/* 表单操作区 */
.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-sm);
  padding-top: var(--ds-spacing-md);
  border-top: 1px solid var(--ds-gray-200);
}

.border-radius {
  border-radius: 4px;
}
</style>
